module.exports = __webpack_public_path__ + "static/media/curr_score_icon.edf5779c.JPG";